<template>
    <i
        variant="primary"
        @click="toAtualizar()"
        v-if="mostrarBtnAtualizar">
    </i>
</template>

<script>
export default {
    props: {
        feriado: {
            type: Object
        }
    },

    methods: {
        toAtualizar() {
            this.$router.push({
                name: 'Feriado_Atualizar',
                params: {
                    feriadoId: this.feriado.feriadoId,
                }
            })
        }
    },

    computed: {
        mostrarBtnAtualizar() {
            return this.$temAcessoView('ADMIN-FERIADOS-03')
        }
    }
}
</script>